import gql from 'graphql-tag';

export const SEND_OCA_LINK = gql`
  mutation SendOcaLink($input: SendOcaLinkInput!) {
    sendOcaLink(input: $input) {
      success
      errorMessage
    }
  }
`;
